import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Ligne / carte cliquable vers une fiche.
// - clic simple → navigation Turbo
// - ⌘/Ctrl-clic, clic molette → nouvel onglet (comme un vrai lien)
// - Entrée au clavier → navigation (l'élément reçoit tabindex + role="link")
// Le nom de l'entité reste un vrai <a> dans le partial : clic droit / "ouvrir dans
// un nouvel onglet" y fonctionnent nativement.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (!this.element.hasAttribute("tabindex")) this.element.setAttribute("tabindex", "0")
    if (!this.element.hasAttribute("role")) this.element.setAttribute("role", "link")
    this.onAuxClick = (event) => { if (event.button === 1) this.openInNewTab(event) }
    this.onKeydown = (event) => {
      if (event.key !== "Enter" || event.target !== this.element) return
      event.preventDefault()
      this.visit(event)
    }
    this.element.addEventListener("auxclick", this.onAuxClick)
    this.element.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    this.element.removeEventListener("auxclick", this.onAuxClick)
    this.element.removeEventListener("keydown", this.onKeydown)
  }

  navigate(event) {
    if (this.isInteractive(event.target)) return
    this.visit(event)
  }

  // Zone qui ne doit pas déclencher la navigation (case à cocher, menu…)
  stop(event) {
    event.stopPropagation()
  }

  visit(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return this.openInNewTab(event)
    Turbo.visit(this.urlValue)
  }

  openInNewTab(event) {
    if (this.isInteractive(event.target)) return
    event.preventDefault()
    window.open(this.urlValue, "_blank", "noopener")
  }

  isInteractive(target) {
    return Boolean(target.closest("a, button, input, label, select, textarea, [data-row-link-ignore]"))
  }
}
